<template>
    <div id="client-detail">
        <div class="ibox-heading d-flex justify-space-between">
            <h1>
                {{ title }}
            </h1>

            <client-detail-actions
                :rdp="data.rdp"
                :rdp-host="data.rdp_host"
                :rdp-port="data.rdp_port"
                :ip="client.client_mms.ip"
                :teamviewer="client.teamviewer"
                :pov-port="data.pov_port"
                :no-support="data.no_support"
                :status-url="data.status_url"
                :connection-direct="data.connection_direct"
            />
        </div>

        <div v-if="client.client_mms.fake">
            <div class="row">
                <div class="col-md-12">
                    <client-detail-systemlog
                        :id="client.client_mms.id"
                        limit="10"
                    />
                </div>
            </div>
        </div>

        <div v-else>
            <div class="row">
                <div class="col-md-8">

                    <div class="row m-b-lg">
                        <div class="col-md-12">
                            <client-detail-systemlog
                                :id="client.client_mms.id"
                                limit="5"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <client-detail-playlog
                                :id="client.client_mms.id"
                                limit="5"
                            />
                        </div>
                    </div>

                </div>

                <div class="col-md-4">
                    <client-detail-status
                        :ip="client.client_mms.ip"
                        :id="client.client_mms.id"
                        :name="client.client_mms.displayed_name"
                        :connection-direct="data.connection_direct"
                    />
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import ClientDetailActions from './actions.vue';
import ClientDetailPlaylog from './playlog.vue';
import ClientDetailStatus from './status.vue';
import ClientDetailSystemlog from './systemlog.vue';

export default {
    name: "ClientDetail",
    components: {
        ClientDetailActions,
        ClientDetailPlaylog,
        ClientDetailStatus,
        ClientDetailSystemlog
    },

    props: {
        /**
         * @type {ClientDetailResponse}
         */
        client: {type: Object, required: true},
        /**
         * @type {ClientDetailData}
         */
        data: {type: Object, required: true},
    },

    computed: {
        title() {
            const name = this.client.client_mms.displayed_name || "";
            return `Client Details for "${name}"`;
        }
    }
};
</script>
